import { render, staticRenderFns } from "./TischnummerDialog.vue?vue&type=template&id=505e481c&scoped=true"
import script from "./TischnummerDialog.vue?vue&type=script&lang=js"
export * from "./TischnummerDialog.vue?vue&type=script&lang=js"
import style0 from "./TischnummerDialog.vue?vue&type=style&index=0&id=505e481c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e481c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505e481c')) {
      api.createRecord('505e481c', component.options)
    } else {
      api.reload('505e481c', component.options)
    }
    module.hot.accept("./TischnummerDialog.vue?vue&type=template&id=505e481c&scoped=true", function () {
      api.rerender('505e481c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/TischnummerDialog.vue"
export default component.exports